import { Modal, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function ShipmentTypeFptModal({ isOpen, setIsOpen }) {
  const { t } = useTranslation();

  const shipmentTypeFptList = t('shipmentTypeFptList', { returnObjects: true });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={setIsOpen}
      primaryButtonProps={{
        children: t('okay'),
        onClick: () => setIsOpen(false)
      }}
      title={t('shipmentTypeFptTitle')}
    >
      <S.ShipmentTypeModal>
        <Typography variant="body3">{t('shipmentTypeFptDescription')}</Typography>
        <ul style={{ margin: '16px 0' }}>
          {shipmentTypeFptList.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </S.ShipmentTypeModal>
    </Modal>
  );
}

export { ShipmentTypeFptModal };

ShipmentTypeFptModal.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func
};
